import { API, Portal } from "@thenounproject/lingo-core";

import { createQueryAction } from "@actions/actionCreators";

type Args = {
  portalId: number | string;
};

const [usePortal, fetchPortal] = createQueryAction<Args, Portal, string>(
  {
    entity: "portals",
    action: "fetch",
    condition: ({ args: { portalId } }) => Boolean(portalId),
    prefetchData: ({ args }, { getState }) => {
      const state = getState();
      const portalId = state.entities.shortIds.portals?.[args.portalId] ?? args.portalId;
      const portal = state.entities.portals.objects[portalId];
      if (!portal) return null;
      return {
        result: portal.uuid,
        entities: {
          portals: {
            [portal.uuid]: portal,
          },
        },
      };
    },
  },
  async ({ args }) => {
    const res = await API.call<{ portal: string }>({
      endpoint: `portals/${args.portalId}`,
      method: "GET",
    });
    return { ...res, result: res.result.portal };
  }
);

export default usePortal;
export { fetchPortal };
